export const FETCH_ACTIVEUNIT = "FETCH_ACTIVEUNIT";
export const SET_ACTIVEUNIT = "SET_ACTIVEUNIT";
export const UPDATE_ACTIVE_SKILL = "UPDATE_ACTIVE_SKILL";
